<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="btn">
			<div class="jiams tj">
				<div>请选择设备：</div>
				<Select v-model="query.macs" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
				        <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="time tj">
				<div>请选择时间：</div>
				<div class="time-xz">
					<DatePicker type="datetime" placeholder="开始时间" v-model="kaishi" style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model="jieshu" style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"  ></DatePicker>
				</div>
			</div>
		</div>
		<div class="tongji">
			<div class="item">
				<div class="item-title">交易总金额：</div>
				<div class="item-title">{{map.yearMoney/100}}元</div>
			</div>
			<!-- <div class="item">
				<div class="item-title">本月总金额：</div>
				<div class="item-title">{{map.monthMoney/100}}元</div>
			</div>
			<div class="item">
				<div class="item-title">当日总金额：</div>
				<div class="item-title">{{map.dayMoney/100}}元</div>
			</div> -->
		</div>

		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="xiangqing(row)">详情</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading:false,
				kaishi:'',
				jieshu:'',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: '订单id',
						key: 'id'
					},
					{
						title: '支付方式',
						key: 'payType'
					},
					{
						title: '设备编号',
						key: 'macCode'
					},
					{
						title: '总金额',
						key: 'money',
						render: (h, params) => {
							return h("div",params.row.money)
						}
					},
					{
						title: '出货结果',
						key: 'result'
					},
					{
						title: '是否退款',
						key: 'refund'
					},
					{
						title: '时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 80,
						align: 'center'
					}
				],
				data6: [
					/* {
					id: '1',
					name: 'XXX机器人',
					address: '渝北区泰山大道东段',
					isRefrigerate: '冷藏',
					startUsing: '启用',
					state: '正常',
					isStockout: '正常',
					useOperOperator: "XXXX",
					createdTime: '2010-10-10'
				} */
				],
				query: {
					page: '0',
					size: '10',
					//开始时间
					kaishiTime:'',
					//结束时间
					jieshuTime:'',
					macs:[]
					
				},
				map:{
					yearMoney:'--',
					monthMoney:'--',
					dayMoney:'--'
				}
			}
		},
		methods: {
			xiangqing(item){
				let _this=this
				this.$router.push({
					name: 'alliance/finance/list1',
					query: {
						orderId: item.id,
					}
				})
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				_this.query.kaishiTime=time
			},
			onchangeJieshu(time){
				let _this=this
				_this.query.jieshuTime=time
			},
			onok(){
				let _this=this
				_this.query.page=0
				
				let ks=new Date(_this.query.kaishiTime).getTime()
				let js=new Date(_this.query.jieshuTime).getTime()
				let d=Math.floor((js-ks)/(24*3600*1000))
				console.log(d)
				if(d<=31){
					if(ks >=js){
						_this.$Message.error('开始时间必须小于结束时间!');
					}else{
						
						this.showPage = false
						this.$nextTick(() => {
							this.showPage = true
						}) 
						_this.ajaxPage()
						this.queryOperStatistics()
					}
					
				}else{
					
					_this.$Message.error('查询时间支持的最大跨度为31天!');
				}
			},
			onclear(){
				let _this=this
				_this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
				this.queryOperStatistics()
			},
			onchangeSousuo(){
				
				let _this=this
				_this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			    this.queryOperStatistics()
			},
			//查询条件
			selection(){
				
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fin/report/comm/page/alliance',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryOperStatistics(){
				let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fin/report/comm/page/alliance/statistics',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.map = data.map
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryMacs(){
				this.loading = true  
				let _this=this
				let q={page:0,size:1000}
				http.http({
				   //这里是你自己的请求方式、url和data参数
				   method: 'post',
				   url: http.url + '/fac/mac/leave/factory/page/alliance',
				   data: q,
				   _this: _this,
				   success: function(data) {
				   	let items = data.macFaultDetailss.content
				   	for (let i = 0; i < items.length; i++) {
				   		let a={
				   			value: '',
				   			label: ''
				   		}
				   		a.value=items[i].id
				   		a.label=items[i].macCode
				   		_this.macs.push(a)
				   	}
				   }
				   //假设后台需要的是表单数据这里你就可以更改
				 })
					
			}
			

		},
		components: {
			page
		},
		created() {
			let _this=this
			this.query.macs=[]
			_this.kaishi=_this.$route.query.kaishi
			_this.jieshu=_this.$route.query.jieshu
			_this.query.kaishiTime=_this.$route.query.kaishi
			_this.query.jieshuTime=_this.$route.query.jieshu
			
			this.query.macs.push(Number(this.$route.query.macId))
			
			
			this.ajaxPage()
			this.queryOperStatistics()
			this.queryMacs()
		},
		
		//修改首页的meta值，false时再次进入页面会重新请求数据。
		beforeRouteLeave(to, from, next) {
			if(to.name=='alliance/finance/list/mac'){
				from.meta.keepAlive = false;
				this.$destroy(); //销毁B的实例
				next();//当我们前进的不是C时我们让B页面刷新
			}else{
				to.meta.keepAlive=false;
				next()
			}
		}, 
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
		display: flex;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/alliance/finance/list.vue